import { ActionReducerMap } from '@ngrx/store';
import { RedirectionState, reducer } from './reducer';

export const featureKey = 'redirection-mechanism';

export interface RedirectionFeatureState {
  redirection?: RedirectionState;
}

export const reducers: ActionReducerMap<RedirectionFeatureState> = {
  redirection: reducer,
};
